(function($){

	$("#lnm-account-unregister-form").validate({

        ignore: [],
        rules: {
        	"password_unregister" : {
        		required: true,
        		minlength: 8,
        	},
        },
        messages: {
            "password_unregister" : {
                required: "Este campo es obligatorio",
                minlength: "La contraseña debe tener un mínimo de 8 caracteres"
            },
        },
        errorPlacement: function(error, element) {
            error.appendTo( $(element).closest(".form-field").find('.form-field__feedback-container') );
        },
        highlight: function(element) {
            $(element).closest(".form-field").addClass('form-field--has-error');
        },
        unhighlight: function(element) {
            $(element).closest(".form-field").removeClass('form-field--has-error');
        },

        submitHandler: function(form){

            $.ajax({
		        type: "POST",
		        dataType: "json",
		        url: var_lnm_ajax.url,
		        data: {
		        	action : var_lnm_ajax.action,
					nonce: var_lnm_ajax.nonce,
					callback: 'lnm-unregister-user',
					formData: $(form).serialize(),
		        },
		        success: function(response){

		        	console.log(response);

					let generic = [];

					jQuery.each(response, function(key,value){

						if(key == 'type'){
							return;
						}

						let fieldName = key.split('__');
							fieldName = fieldName[0]; 

						let formField = $('[name="'+ fieldName +'"]').closest('.form-field');

						if(formField.length > 0){
							formField.addClass('form-field--has-error');
							formField.find('.form-field__feedback-container').text(value);
						}else{
							generic.push(value);
						}

					});

					if(generic.length > 0){

						let type = response.type;

						if(type === 'success'){
							window.location.href = '/';
							return;
						}

						let alertClass = "lnm-alert lnm-alert--" + type;

						let lnmAlert  = $('<div>', {"class": alertClass} );

						jQuery.each(generic,function(key,value){
							let paragraph = $('<p>');
							paragraph.html(value);
							lnmAlert.append(paragraph);
						});

						$(form).before(lnmAlert);
						$(form).remove();
					}
		        },
		        error : function(jqXHR, textStatus, errorThrown) {
		        	console.log('Error en test ajax');
		        	console.log(errorThrown);
		        }

		    }); // $.ajax
        }
    })

})(jQuery)